export const CACHE_PREFIX = 'gdx_';

export function setCache(key: string, value: string) {
  localStorage.setItem(CACHE_PREFIX + key, value);
}

export function getCache(key: string): string | null {
  return localStorage.getItem(CACHE_PREFIX + key);
}

export function removeCache(key: string): void {
  localStorage.removeItem(CACHE_PREFIX + key);
}

export function hasCache(key: string): boolean {
  return getCache(key) !== null;
}
